import { useIntl } from 'react-intl';

export type TableCellHeaderProps = {
  header: string;
  headerFallback?: string;
};

export const TableCellHeader = (props: TableCellHeaderProps) => {
  const intl = useIntl();
  return intl.formatMessage({ id: props.header, defaultMessage: props?.headerFallback });
};
